import { format } from 'date-fns';
import { Typography } from '@mui/material';
import { getLocalDate } from '@surfline/web-common';

import styles from './WindStationOffline.module.scss';

interface WindStationOfflineProps {
  lastObservedTimestamp?: number;
  utcOffset: number;
}

const WindStationOffline: React.FC<WindStationOfflineProps> = ({
  lastObservedTimestamp = undefined,
  utcOffset,
}) => (
  <>
    <Typography variant="callout2" component="h2" sx={{ mb: '10px' }}>
      Wind
    </Typography>
    <Typography
      variant="headline"
      className={styles.stationOfflineHeading}
      component="h2"
      sx={{ mb: '6px' }}
    >
      Station Offline
    </Typography>
    {!!lastObservedTimestamp && (
      <Typography
        variant="callout2"
        color="text.secondary"
        sx={{ mb: 2.5 }}
        data-testid="last-observed-label"
      >
        Last observed at {`${format(getLocalDate(lastObservedTimestamp, utcOffset), 'h:mmaaa')}`}
      </Typography>
    )}
  </>
);

export default WindStationOffline;
